import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useChangePassword = () => {
  const token = getToken();

  return useMutation({
    mutationFn: (payload: { oldPassword: string; password: string }) =>
      axiosInstance
        .patch("/admins/change-password", payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    onSuccess: async (data) => {
      message.success(data?.message || "New Password created successfully.");
    },
    onError: (error: any) => {
      message.error(
        error?.response?.data?.message || "Failed. Please try again."
      );
    },
  });
};
